import { atom } from "recoil";

// LIMEの寄与度結果
export const LIMEState = atom<Record<string, number> | null>({
  key: "LIMEState",
  default: null,
});
